var pomlo_app = {};

// Define constants
pomlo_app.MOBILE_MAX_WIDTH = 768;
pomlo_app.TABLET_MAX_WIDTH = 992;
pomlo_app.DEFAULT_DURATION = 300;
pomlo_app.SMALL_HEADER_HEIGHT = 60;
pomlo_app.LARGE_HEADER_HEIGHT = 88;

/**
* Function to scroll to a specific html element
*/
pomlo_app.scrollTo = function(selector) {
    $(selector)[0].scrollIntoView();
};

pomlo_app.heroFilter = function() {
    if (jQuery(window).width() > pomlo_app.MOBILE_MAX_WIDTH) {
        $( ".slide" ).find('#filter').remove();
    } else if (($( ".slide" ).find('#filter')).length === 0){
        $( ".slide" ).append('<div id="filter" class="filter filter-white-60"></div>');
    }
};

/**
* Main jQuery events
*/
jQuery(document).ready(function($) {
    pomlo_app.heroFilter();

    // Setup intersection observers to trigger actions
    // pomlo_app.observeKeywordsSection();

    // Init OWL hero slider
    $("#homeHeroSlider").owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 7000,
        nav: false,
        dots: false,
        onInitialized: function(event){
            if (event.item.count === 1) {
                jQuery("#heroSliderPrev").hide();
                jQuery("#heroSliderNext").hide();
            }
        }
    });



    owlHeroSlider = jQuery("#homeHeroSlider").owlCarousel();
    jQuery("#heroSliderPrev").click(function () {
        owlHeroSlider.trigger("prev.owl.carousel");
    });

    jQuery("#heroSliderNext").click(function () {
        owlHeroSlider.trigger("next.owl.carousel");
    });

    // Init OWL hero slider for the new carrousel
    $("#homeHeroSlider-2").owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 8000,
        nav: false,
        dots: false,
        onInitialized: function(event){
            if (event.item.count === 1) {
                jQuery("#heroSliderPrev-2").hide();
                jQuery("#heroSliderNext-2").hide();
            }
        }
    });

    var owlHeroSlider2 = jQuery("#homeHeroSlider-2").owlCarousel();
    jQuery("#heroSliderPrev-2").click(function () {
        owlHeroSlider2.trigger("prev.owl.carousel");
    });

    jQuery("#heroSliderNext-2").click(function () {
        owlHeroSlider2.trigger("next.owl.carousel");
    });

    jQuery("#homeWhoSlider").owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayHoverPause: true
    });

    // Menu button
    $("#btn-menu-open, #btn-menu-close").click(function() {
        $(".offcanvas").toggleClass("active");
    });

    $(".hide-menu").click(function() {
        $(".offcanvas").removeClass("active");
    });

    // Removes some anchor links managed by js click/animatescroll.
    // And manage scroll buttons
    $(".scroll-link").removeAttr("href");

    $(".scroll-to-top").click(function() {
        pomlo_app.scrollTo("#page-top");
    });

    $(".scroll-to").click(function(){
        pomlo_app.scrollTo($(this).attr("data-target"));
        //$(".offcanvas").removeClass("active");
    });

    document.getElementById('form-contact').addEventListener('submit', async (e) => {
      e.preventDefault();
      const form = e.target;
      const notification = document.getElementById('form-notification');

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
        });

        if (!response.ok) throw new Error('Submission failed');

        form.reset();
        notification.textContent = 'Votre demande a bien été envoyée, nous vous contacterons dans les plus brefs délais.';
        notification.hidden = false;
      } catch {
        notification.textContent = 'Une erreur est survenue, veuillez réessayer.';
        notification.hidden = false;
      }
    });
});

jQuery("#main-content").scroll(function() {
});

jQuery(window).resize(function() {
    pomlo_app.heroFilter();
});
